import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';
// import { FileItem } from '@app_modules/loan-products/step1/file-item';

interface Response extends BackendResponse {}

interface Payload {
  id: number|string;
}

export function useRemoveItemLoanProgram(id: number|string) {
  return useMutation({
    mutationFn: ({id}: Payload) =>
      removeItemRateSheet({id: id}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just removed one item.`),
        );
      }
      
      // queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${id}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function removeItemRateSheet({
  id
}: Payload): Promise<Response> {
  return apiClient
    .post(`loan-products/${id}/loan-program-remove-item`)
    .then(r => r.data);
}

